import {Injectable} from '@angular/core';
import {delay, tap} from 'rxjs/operators';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import { IAccount, IUnassignedAccountsRequest, UnAssignedAccountCount, IAccountNameList,IUnassignedAccountExportRequest} from '@irb/irb-clients/irb-clients.model';

@Injectable({ providedIn: 'root' })
export class UnAssignedAccountService {

    _filterCriteria: string = '';
    _sortCriteria: string = '';
    paramsForAcctNum: string;
    paramsForAcctName: string;
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type':  'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        })
      };

    constructor(private readonly http: HttpClient) {}

    getUnAssignedAccounts(params: any, filterKeys: string, showHiddenAccounts: boolean): Observable<HttpResponse<IAccount[]>> {
        const headers = new HttpHeaders({
            'X-HTTP-Method-Override':'GET',
            'Filter-Item':'items=' + params.request.startRow + '-' + (--params.request.endRow)
          });
        filterKeys = '';
        
        if (params.request.sortModel.length > 0) {
            const sortColumn = params.request.sortModel[0].colId;
            const sortOrder = (params.request.sortModel[0].sort === 'asc') ? '+' : '-';
            this._sortCriteria = 'sort(' + sortOrder + sortColumn + ')';
        }

        if (params.request.filterModel && params.request.filterModel['accountName']) {
            if (params.request.filterModel['accountName'].values) {
                filterKeys = filterKeys + '%26accountId%3D' + params.request.filterModel['accountName'].values;
            }
        }

        if (params.request.filterModel && params.request.filterModel['accountNumber']) {
            if (params.request.filterModel['accountNumber'].values) {
                filterKeys = filterKeys + '%26accountNumber%3D' + params.request.filterModel['accountNumber'].values;
            }
        }

        if (params.request.filterModel && params.request.filterModel['masterAccount']) {
            if (params.request.filterModel['masterAccount'].values) {
                filterKeys = filterKeys + '%26masterAccount%3D' + params.request.filterModel['masterAccount'].values;
            }
        }

        if (params.request.filterModel && params.request.filterModel['marketValue']) {
            let minvalue = params.request.filterModel['marketValue'].filter;
            let maxvalue = params.request.filterModel['marketValue'].filterTo;
            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26acctMktValueFilter%3D' + minmaxvalue;
            }
        }

        this._filterCriteria = filterKeys;
        
        return this.http.post<IAccount[]>(`/irebalone/accounts/unassigned-acc-inv?visibilityToggleVal=${showHiddenAccounts}&` + this._sortCriteria ,{Filter:filterKeys},
            {headers: headers , observe: 'response'})
            .pipe(delay(1000), tap(_res => {
                    //console.log(res.headers.get('Filter-Count'));
                })
            );
    }

    getUnAssignedAccountCount(): Observable<UnAssignedAccountCount> {
        return this.http.get<UnAssignedAccountCount>('irebalone/accounts/get-unassigned-account-count').pipe(delay(1000));
    }

    getComboDropDownValues(params: any): Observable<string[]> {
        return this.http.get<string[]>('/irebalone/accounts/unassigned-account-values' + '/' + encodeURI(params)).pipe(delay(1000));
    }

    getAccountNameDropDownValues(params: any): Observable<IAccountNameList> {
        return this.http.get<IAccountNameList>('/irebalone/accounts/account-names' + '/' + encodeURI(params)).pipe(delay(1000));
    }

    getUnassignedAccountNumber(): Observable<any> {
        return this.http.get('/irebalone/accounts/unassigned-account-number' + '/' + encodeURI(this.paramsForAcctNum)).pipe(delay(1000));
    }

    getUnassignedAccountName(): Observable<any> {
        let url = '/irebalone/accounts/unassigned-account-name';
        return this.http.get(url + '?s=' + encodeURI(this.paramsForAcctName)).pipe(delay(1000));
    }

    getAccountsToBeProcessed(data: IUnassignedAccountsRequest): Observable<Object> {
        data.filter = this._filterCriteria !== undefined ? this._filterCriteria : '';
        return this.http.post("/irebalone/accounts/get-accounts-to-be-processed", JSON.stringify(data), this.httpOptions);
    }

    assignAccountsToPortfolio(data: IUnassignedAccountsRequest): Observable<Object> {
        return this.http.post("/irebalone/accounts/assign-accounts-to-portfolio", JSON.stringify(data), this.httpOptions);
    }

    /*assignAccountsToOwnPortfolio(data: IUnassignedAccountsRequest): Observable<Object> {
        return this.http.post("/irebalone/accounts/assign-accounts-to-own-portfolio", JSON.stringify(data), this.httpOptions);
    }*/

    exportUnassignedAccountsDetails(data: IUnassignedAccountExportRequest):Observable<any> {
        data.filter = this._filterCriteria !== undefined ? this._filterCriteria : '';
        data.sort = this._sortCriteria !== undefined ? this._sortCriteria : '';
        return this.http.post('/irebalone/accounts/async/export-unassigned-account-details', JSON.stringify(data), this.httpOptions);
    }

    updateAccountVisibility(request: { accountIds: number[], isVisible: boolean }): Observable<Object> {
        return this.http.post('/irebalone/accounts/update-account-visibility', JSON.stringify(request), this.httpOptions);
    }
}
